import router from './router';
import store from './store';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条样式
import { Message } from 'element-ui';
import { getToken } from '@/utils/auth'; // 验权

// 路由权限校验
function hasPermission(roles, permissionRoles) {
  // console.log(permissionRoles)
  if (store.getters.userinfo.role === 'admin') return true; // admin
  if (!permissionRoles) return true; // 无须权限的路由
  return roles.some(role => permissionRoles.indexOf(role) >= 0);
}

const whiteList = ['/login']; // 不重定向白名单

router.beforeEach((to, from, next) => {
  NProgress.start();
  
  if (getToken()) { // 登录状态
    if (to.path === '/login') { // 返回首页
      next({
        path: '/'
      });
      NProgress.done(); // 进度条
    } else {
      // console.log(store.getters.menus)
      if (store.getters.menus.length === 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          //防止地址栏直接输入
          // console.log(res)
          // if (hasPermission(store.getters.roles, to.meta.roles)) {
            next(); // 有权限
          // } else {
            // next({
            //   path: '/403'
            // });
            NProgress.done();
          // }
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || '用户权限验证失败，请再次登录');
            next({
              path: '/'
            });
          });
        });
      } else {
        // if (hasPermission(store.getters.roles, to.meta.roles) || to.path === '/order/list') {
          // next(); // 有权限
        // } else {
          next();    //暂时不用权限限制
          // next({
          //   path: '/403'
          // });
          NProgress.done();
        // }
      }
    }
  } else { // 未登录
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next('/login');
      NProgress.done();
    }
  }
});

router.afterEach((to, from) => {
  NProgress.done(); // 结束Progress
});


// WEBPACK FOOTER //
// ./src/permission.js